import React, { useMemo, useState, useEffect } from "react";
import "../styles/bodyRegionMap.css";
import frontImg from "../../images/front-body-muscles.png";
import backImg from "../../images/back-body-muscles.png"


const REGION_LABELS = {
  head_jaw: "Head / jaw",
  neck: "Neck",
  chest: "Chest",
  abdomen: "Abdomen",
  upper_back: "Upper back / thoracic",
  low_back: "Low back / lumbar",
  left_shoulder: "Left shoulder",
  right_shoulder: "Right shoulder",
  left_upper_arm: "Left upper arm",
  right_upper_arm: "Right upper arm",
  left_elbow: "Left elbow",
  right_elbow: "Right elbow",
  left_forearm: "Left forearm",
  right_forearm: "Right forearm",
  left_wrist_hand: "Left wrist / hand",
  right_wrist_hand: "Right wrist / hand",
  left_outer_hip: "Left hip / outer hip",
  right_outer_hip: "Right hip / outer hip",
  groin: "Groin / front hip",
  left_glute: "Left glute / buttock",
  right_glute: "Right glute / buttock",
  left_thigh: "Left thigh / upper leg",
  right_thigh: "Right thigh / upper leg",
  left_hamstring: "Left hamstring",
  right_hamstring: "Right hamstring",
  left_knee: "Left knee",
  right_knee: "Right knee",
  left_calf_shin: "Left calf / shin",
  right_calf_shin: "Right calf / shin",
  left_ankle_foot: "Left ankle / foot",
  right_ankle_foot: "Right ankle / foot",
  left_achilles_heel: "Left Achilles / heel",
  right_achilles_heel: "Right Achilles / heel",
};

const FRONT_REGIONS = [
  { id: "head_jaw", label: REGION_LABELS.head_jaw, d: "M84 3 L116 3 L125 32 L115 58 L83 58 L73 32s Z" },/* */
  { id: "neck", label: REGION_LABELS.neck, d: "M83 58 L115 58 L116 65 L143 77 L122 83 L78 83 L50 77 L81 65Z" },/** */
  { id: "chest", label: REGION_LABELS.chest, d: "M50 104 L65 83 L132 83 L147 104 L148 137 L50 137 Z" },/** */
  { id: "abdomen", label: REGION_LABELS.abdomen, d: "M148 137 L140 160 L139 208 L126 218 L72 218 L59 208 L60 160 L50 137 Z" },/** */
  { id: "groin", label: REGION_LABELS.groin, d: "M72 218 L126 218 L104 258 L94 258 Z" },
  { id: "right_shoulder", label: REGION_LABELS.right_shoulder, d: "M48 77 L65 83 L50 104 L27 116 L30 93 Z" },/** */
  { id: "left_shoulder", label: REGION_LABELS.left_shoulder, d: "M152 79 L132 83 L147 104 L171 116 L170 95 Z" },/** */
  { id: "right_upper_arm", label: REGION_LABELS.right_upper_arm, d: "M27 116 L50 104 L50 137 L40 156 L14 152 L18 138 Z" },/** */
  { id: "left_upper_arm", label: REGION_LABELS.left_upper_arm, d: "M171 116 L147 104 L148 137 L158 156 L184 152 L180 138 Z" },/** */
  { id: "right_elbow", label: REGION_LABELS.right_elbow, d: "M14 152 L40 156 L34 175 L23 175 Z" },/** */
  { id: "left_elbow", label: REGION_LABELS.left_elbow, d: "M184 152 L158 156 L163 175 L175 175 Z" },/** */
  { id: "right_forearm", label: REGION_LABELS.right_forearm, d: "M14 152 L23 175 L36 175 L8 226 L-10 220 Z" },/** */
  { id: "left_forearm", label: REGION_LABELS.left_forearm, d: "M184 152 L175 175 L162 175 L190 226 L208 220 Z"},/** */
  { id: "right_wrist_hand", label: REGION_LABELS.right_wrist_hand, d: "M8 226 L-1 270 L-10 275 L-22 271 L-25 256 L-10 220 Z" },/** */
  { id: "left_wrist_hand", label: REGION_LABELS.left_wrist_hand, d: "M190 226 L201 270 L210 275 L222 271 L225 256 L208 220 Z" },/**~ */
  { id: "right_outer_hip", label: REGION_LABELS.right_outer_hip, d: "M59 208 L72 218 L65 240 L62 245 L50 260 L53 238 Z" },/** */
  { id: "left_outer_hip", label: REGION_LABELS.left_outer_hip, d: "M139 208 L126 218 L133 240 L136 245 L148 260 L145 238 Z" },
  { id: "right_thigh", label: REGION_LABELS.right_thigh, d: "M50 260 L72 230 L94 258 L93 300 L86 345 L72 345 L70 332 L51 332 L46 300 Z" },/** */
  { id: "left_thigh", label: REGION_LABELS.left_thigh, d: "M148 260 L126 230 L104 258 L105 300 L112 345 L126 345 L128 332 L147 332 L152 300 Z" },
  { id: "right_knee", label: REGION_LABELS.right_knee, d: "M51 334 L70 334 L72 346 L84 348 L80 364 L73 370 L63 371 L59 368 Z" }, /** */
  { id: "left_knee", label: REGION_LABELS.left_knee, d: "M147 334 L128 334 L126 346 L114 348 L118 364 L125 370 L135 371 L139 368 Z" },
  { id: "right_calf_shin", label: REGION_LABELS.right_calf_shin, d: "M54 370 L74 373 L82 365 L86 406 L74 464 L59 464 L55 413 Z" },/** */
  { id: "left_calf_shin", label: REGION_LABELS.left_calf_shin, d: "M144 370 L124 373 L116 365 L112 406 L124 464 L139 464 L143 413 Z" },
  { id: "right_ankle_foot", label: REGION_LABELS.right_ankle_foot, d: "M59 464 L77 464 L77 490 L63 496 L43 496 L55 479 Z" },/** */
  { id: "left_ankle_foot", label: REGION_LABELS.left_ankle_foot, d: "M139 464 L121 464 L121 490 L135 496 L155 496 L143 479 Z" },
];

const BACK_REGIONS = [
  { id: "head_jaw", label: REGION_LABELS.head_jaw, d: "M85 5 L115 5 L124 35 L117 58 L83 58 L73 35 Z" },/** */
  { id: "neck", label: REGION_LABELS.neck, d: "M82 58 L116 58 L116 68 L140 80 L117 90 L80 90 L60 80 L82 68 Z" },/** */
  { id: "upper_back", label: REGION_LABELS.upper_back, d: "M64 83 L80 90 L117 90 L136 83 L149 140 L134 178 L120 178 L110 168 L90 168 L80 178 L64 178 L49 140 Z" },
  { id: "low_back", label: REGION_LABELS.low_back, d: "M64 178 L80 178 L90 168 L110 168 L120 178 L134 178 L138 205 L110 210 L90 210 L60 205Z" },
  { id: "left_shoulder", label: REGION_LABELS.left_shoulder, d: "M38 84 L64 78 L57 108 L27 116 L28 100 Z" },/**/
  { id: "right_shoulder", label: REGION_LABELS.right_shoulder, d: "M161 85 L134 78 L143 108 L171 116 L169 100 Z" },
  { id: "left_upper_arm", label: REGION_LABELS.left_upper_arm, d: "M27 116 L57 109 L36 167 L32 168 L15 160 L17 140 Z" },/** */
  { id: "right_upper_arm", label: REGION_LABELS.right_upper_arm, d: "M170 116 L142 109 L160 167 L166 168 L185 160 L179 140 Z"},
  { id: "left_elbow", label: REGION_LABELS.left_elbow, d: "M14 160 L34 169 L35 179 L22 183 L16 180 L9 167 Z" },/** */
  { id: "right_elbow", label: REGION_LABELS.right_elbow, d: "M186 160 L160 171 L162 179 L178 183 L184 180 L191 167 Z" },
  { id: "left_forearm", label: REGION_LABELS.left_forearm, d: "M8 167 L16 180 L22 183 L35 180 L8 226 L-7 220 Z" },
  { id: "right_forearm", label: REGION_LABELS.right_forearm, d: "M192 167 L184 180 L178 183 L162 180 L189 226 L207 220 Z" },
  { id: "left_wrist_hand", label: REGION_LABELS.left_wrist_hand, d: "M8 226 L-1 269 L-10 275 L-22 273 L-25 256 L-7 220 Z" },
  { id: "right_wrist_hand", label: REGION_LABELS.right_wrist_hand, d: "M189 226 L199 269 L210 275 L222 273 L225 256 L207 220 Z" },
  { id: "left_glute", label: REGION_LABELS.left_glute, d: "M75 213 L99 230 L98 264 L85 270 L68 270 L62 250 L68 226 Z" },
  { id: "right_glute", label: REGION_LABELS.right_glute, d: "M123 213 L101 230 L100 264 L115 270 L132 270 L138 250 L132 226 Z" },
  { id: "left_outer_hip", label: REGION_LABELS.left_outer_hip, d: "M60 205 L75 213 L68 226 L62 250 L68 270 L51 257 L55 228 Z" },
  { id: "right_outer_hip", label: REGION_LABELS.right_outer_hip, d: "M138 205 L123 213 L132 226 L138 250 L132 270 L147 257 L143 228 Z" },
  { id: "left_hamstring", label: REGION_LABELS.left_hamstring, d: "M51 257 L68 270 L85 270 L96 266 L87 351 L78 350 L76 345 L66 340 L63 345 L55 347 L44 308 Z" },
  { id: "right_hamstring", label: REGION_LABELS.right_hamstring, d: "M147 257 L130 270 L113 270 L102 266 L111 351 L120 350 L122 345 L132 340 L135 345 L143 347 L154 308 Z" },
  { id: "left_knee", label: REGION_LABELS.left_knee, d: "M55 347 L63 345 L66 340 L76 345 L78 350 L87 351 L84 367 L55 367 Z" },
  { id: "right_knee", label: REGION_LABELS.right_knee, d: "M143 347 L135 345 L132 340 L122 345 L120 350 L111 351 L114 367 L143 367 Z" },
  { id: "left_calf_shin", label: REGION_LABELS.left_calf_shin, d: "M55 367 L84 367 L86 412 L80 423 L74 406 L67 414 L54 409 Z" },
  { id: "right_calf_shin", label: REGION_LABELS.right_calf_shin, d: "M143 367 L114 367 L112 412 L118 423 L124 406 L131 414 L144 409 Z" },
  { id: "left_achilles_heel", label: REGION_LABELS.left_achilles_heel, d: "M54 409 L67 414 L74 406 L80 423 L74 478 L69 476Z" },
  { id: "right_achilles_heel", label: REGION_LABELS.right_achilles_heel, d: "M144 409 L131 414 L124 406 L118 423 L124 478 L129 476 Z" },
  { id: "left_ankle_foot", label: REGION_LABELS.left_ankle_foot, d: "M58 458 L63 458 L72 479 L78 479 L78 493 L65 500 L44 497 L44 490 L56 480 Z" },
  { id: "right_ankle_foot", label: REGION_LABELS.right_ankle_foot, d: "M140 458 L135 458 L126 479 L120 479 L120 493 L133 500 L154 497 L154 490 L142 480 Z" },
];

const BodyFigure = ({
  title,
  imageSrc,
  regions,
  selectedIds,
  onToggle,
  hoveredId,
  onHover,
}) => (
  <div className="body-map-figure">
    <div className="body-map-figure__title">{title}</div>
    <div className="body-map-figure__canvas">
      <img src={imageSrc} alt={title} className="body-map-figure__image" />
      <svg viewBox="0 0 200 500" className="body-map-figure__svg" aria-label={`${title} interactive body map`}>
        {regions.map((region) => {
          const selected = selectedIds.includes(region.id);
          const hovered = hoveredId === region.id;
          return (
            
            <path
              key={`${title}-${region.id}`}
              d={region.d}
              className={[
                "body-map-region",
                selected ? "is-selected" : "",
                hovered ? "is-hovered" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              role="button"
              tabIndex={0}
              aria-pressed={selected}
              aria-label={region.label}
              onMouseEnter={() => onHover(region.id)}
              onMouseLeave={() => onHover(null)}
              onFocus={() => onHover(region.id)}
              onBlur={() => onHover(null)}
              onClick={() => onToggle(region.id)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onToggle(region.id);
                }
              }}
            /> 
          );
        })}
      </svg>
    </div>
  </div>
);

const BodyRegionMap = ({
  value = [],
  onChange,
  className = "",
  title = "Select the body parts that need focus",
  description = "Choose one or more areas. Your selections will appear below.",
}) => {
  const [hoveredId, setHoveredId] = useState(null);

  const selectedIds = useMemo(() => {
    if (!Array.isArray(value)) return [];
    return value.filter(Boolean);
  }, [value]);

  const selectedLabels = useMemo(
    () => selectedIds.map((id) => ({ id, label: REGION_LABELS[id] ?? id })),
    [selectedIds]
  );

  const toggleRegion = (regionId) => {
    const next = selectedIds.includes(regionId)
      ? selectedIds.filter((id) => id !== regionId)
      : [...selectedIds, regionId];

    onChange?.(next);
  };

  const clearAll = () => onChange?.([]);

  return (
    <section className={`body-region-map ${className}`.trim()}>
      <div className="body-region-map__header">
        <div>
          <h3 className="body-region-map__title">{title}</h3>
          <p className="body-region-map__description">{description}</p>
        </div>

        {selectedIds.length > 0 ? (
          <button type="button" className="body-region-map__clear" onClick={clearAll}>
            Clear all
          </button>
        ) : null}
      </div>

      <div className="body-region-map__grid">
        <BodyFigure
          title="Front"
          imageSrc={frontImg}
          regions={FRONT_REGIONS}
          selectedIds={selectedIds}
          onToggle={toggleRegion}
          hoveredId={hoveredId}
          onHover={setHoveredId}
        />

        <BodyFigure
          title="Back"
          imageSrc={backImg}
          regions={BACK_REGIONS}
          selectedIds={selectedIds}
          onToggle={toggleRegion}
          hoveredId={hoveredId}
          onHover={setHoveredId}
        />
      </div>

      <div className="body-region-map__selected">
        <div className="body-region-map__selected-label">Selected areas</div>

        {selectedLabels.length ? (
          <ul className="body-region-map__chips" role="list">
            {selectedLabels.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  className="body-region-map__chip"
                  onClick={() => toggleRegion(item.id)}
                >
                  <span>{item.label}</span>
                  <span aria-hidden="true"></span>
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="body-region-map__empty">No body area selected yet.</p>
        )}
      </div>
    </section>
  );
};


const BodyDisplayFigure = ({
  title,
  imageSrc,
  regions,
  activeIds,
  hoveredId,
  onHover,
  interactive = false,
}) => (
  <div className="body-map-figure">
    <div className="body-map-figure__title">{title}</div>

    <div className="body-map-figure__canvas">
      <img src={imageSrc} alt={title} className="body-map-figure__image" />

      <svg
        viewBox="0 0 200 500"
        className="body-map-figure__svg"
        aria-label={`${title} body map`}
      >
        {regions.map((region) => {
          const active = activeIds.includes(region.id);
          const hovered = hoveredId === region.id;

          return (
            <path
              key={`${title}-${region.id}`}
              d={region.d}
              className={[
                "body-map-region",
                active ? "is-selected" : "",
                hovered ? "is-hovered" : "",
                interactive ? "is-interactive" : "is-static",
              ]
                .filter(Boolean)
                .join(" ")}
              aria-label={region.label}
              onMouseEnter={() => onHover?.(region.id)}
              onMouseLeave={() => onHover?.(null)}
            />
          );
        })}
      </svg>
    </div>
  </div>
);

const BodyRegionDisplayMap = ({ activeRegions = [], className = "" }) => {
  const [hoveredId, setHoveredId] = useState(null);
  const [selectedSide, setSelectedSide] = useState(null);

  const activeIds = useMemo(() => {
    if (!Array.isArray(activeRegions)) return [];
    return activeRegions.filter(Boolean);
  }, [activeRegions]);

  const frontRegionIds = useMemo(
    () => new Set(FRONT_REGIONS.map((region) => region.id)),
    []
  );

  const hasFrontSelection = useMemo(
    () => activeIds.some((id) => frontRegionIds.has(id)),
    [activeIds, frontRegionIds]
  );

  const defaultSide = hasFrontSelection ? "front" : "back";
  const currentSide = selectedSide ?? defaultSide;

  useEffect(() => {
    setSelectedSide(null);
  }, [defaultSide]);

  const figureProps =
    currentSide === "front"
      ? {
          title: "Front",
          imageSrc: frontImg,
          regions: FRONT_REGIONS,
        }
      : {
          title: "Back",
          imageSrc: backImg,
          regions: BACK_REGIONS,
        };

  const switchSide = () => {
    setSelectedSide((prev) => {
      const effective = prev ?? defaultSide;
      return effective === "front" ? "back" : "front";
    });
  };

  return (
    <section className={`body-region-map ${className}`.trim()}>
      <div className="body-region-map__single">
        <BodyDisplayFigure
          title={figureProps.title}
          imageSrc={figureProps.imageSrc}
          regions={figureProps.regions}
          activeIds={activeIds}
          hoveredId={hoveredId}
          onHover={setHoveredId}
        />
      </div>

      <div className="body-region-map__switcher">
        <button
          type="button"
          className="body-region-map__arrow"
          onClick={switchSide}
          aria-label="Show previous body side"
        >
          ‹
        </button>

        <div className="body-region-map__side-label">
          {currentSide === "front" ? "Front" : "Back"}
        </div>

        <button
          type="button"
          className="body-region-map__arrow"
          onClick={switchSide}
          aria-label="Show next body side"
        >
          ›
        </button>
      </div>
    </section>
  );
};

export default BodyRegionMap;
export { BodyRegionDisplayMap, REGION_LABELS };
